(function () {
  "use strict";

  if (window.__yntServicesNavigationLoaded) {
    if (typeof window.__yntServicesNavigationInitialise === "function") {
      window.__yntServicesNavigationInitialise();
    }
    return;
  }

  window.__yntServicesNavigationLoaded = true;

  var desktopQuery = window.matchMedia("(min-width: 990px)");
  var hoverQuery = window.matchMedia("(hover: hover) and (pointer: fine)");

  function addMediaListener(query, listener) {
    if (query.addEventListener) {
      query.addEventListener("change", listener);
    } else {
      query.addListener(listener);
    }
  }

  function removeMediaListener(query, listener) {
    if (query.removeEventListener) {
      query.removeEventListener("change", listener);
    } else {
      query.removeListener(listener);
    }
  }

  function enhanceServicesMega(root, headerShell) {
    if (!root || root.dataset.servicesMegaReady === "true") {
      return { close: function () {}, cleanup: function () {} };
    }

    root.dataset.servicesMegaReady = "true";
    var toggle = root.querySelector("[data-services-mega-toggle]");
    var panel = root.querySelector("[data-services-mega-panel]");
    var closeTimer = null;
    var hoverOpened = false;

    if (!toggle || !panel) {
      delete root.dataset.servicesMegaReady;
      return { close: function () {}, cleanup: function () {} };
    }

    function isOpen() {
      return root.classList.contains("is-open");
    }

    function clearCloseTimer() {
      if (closeTimer === null) return;
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }

    function openMenu() {
      if (!desktopQuery.matches) return;
      clearCloseTimer();
      root.classList.add("is-open");
      toggle.setAttribute("aria-expanded", "true");
      panel.setAttribute("aria-hidden", "false");
      panel.removeAttribute("inert");
      if (headerShell) headerShell.classList.add("has-services-mega-open");
    }

    function closeMenu(restoreFocus) {
      clearCloseTimer();
      if (!isOpen()) return;
      hoverOpened = false;
      root.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
      panel.setAttribute("aria-hidden", "true");
      panel.setAttribute("inert", "");
      if (headerShell) headerShell.classList.remove("has-services-mega-open");
      if (restoreFocus) toggle.focus();
    }

    function scheduleClose() {
      clearCloseTimer();
      closeTimer = window.setTimeout(function () {
        closeMenu(false);
      }, 150);
    }

    function handleToggleClick(event) {
      event.preventDefault();
      if (isOpen() && hoverOpened) {
        hoverOpened = false;
        return;
      }
      if (isOpen()) {
        closeMenu(false);
      } else {
        openMenu();
      }
    }

    function handleToggleKeydown(event) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        hoverOpened = false;
        if (isOpen()) {
          closeMenu(false);
        } else {
          openMenu();
        }
        return;
      }

      if (event.key === "ArrowDown") {
        event.preventDefault();
        hoverOpened = false;
        openMenu();
        var firstLink = panel.querySelector("a[href]");
        if (firstLink) firstLink.focus();
      }
    }

    function handlePointerEnter() {
      if (!hoverQuery.matches) return;
      if (!isOpen()) hoverOpened = true;
      openMenu();
    }

    function handlePointerLeave() {
      if (!hoverQuery.matches) return;
      scheduleClose();
    }

    function handleFocusOut(event) {
      var nextTarget = event.relatedTarget;
      if (nextTarget && root.contains(nextTarget)) return;
      scheduleClose();
    }

    function handleDocumentPointerDown(event) {
      if (isOpen() && !root.contains(event.target)) closeMenu(false);
    }

    function handleDocumentKeydown(event) {
      if (event.key !== "Escape" || !isOpen()) return;
      event.preventDefault();
      closeMenu(true);
    }

    function handlePanelClick(event) {
      if (event.target.closest("a")) closeMenu(false);
    }

    function handleViewportChange(event) {
      if (!event.matches) closeMenu(false);
    }

    toggle.addEventListener("click", handleToggleClick);
    toggle.addEventListener("keydown", handleToggleKeydown);
    root.addEventListener("pointerenter", handlePointerEnter);
    root.addEventListener("pointerleave", handlePointerLeave);
    root.addEventListener("focusout", handleFocusOut);
    panel.addEventListener("click", handlePanelClick);
    document.addEventListener("pointerdown", handleDocumentPointerDown);
    document.addEventListener("keydown", handleDocumentKeydown);
    addMediaListener(desktopQuery, handleViewportChange);

    return {
      close: closeMenu,
      cleanup: function () {
        closeMenu(false);
        toggle.removeEventListener("click", handleToggleClick);
        toggle.removeEventListener("keydown", handleToggleKeydown);
        root.removeEventListener("pointerenter", handlePointerEnter);
        root.removeEventListener("pointerleave", handlePointerLeave);
        root.removeEventListener("focusout", handleFocusOut);
        panel.removeEventListener("click", handlePanelClick);
        document.removeEventListener("pointerdown", handleDocumentPointerDown);
        document.removeEventListener("keydown", handleDocumentKeydown);
        removeMediaListener(desktopQuery, handleViewportChange);
        delete root.dataset.servicesMegaReady;
      }
    };
  }

  function enhanceMobileDrawer(root, closeMega) {
    if (!root || root.dataset.mobileDrawerReady === "true") {
      return { close: function () {}, cleanup: function () {} };
    }

    root.dataset.mobileDrawerReady = "true";
    var drawerId = root.id;
    var triggers = Array.prototype.slice.call(
      document.querySelectorAll('[data-site-mobile-menu-open][aria-controls="' + drawerId + '"]')
    );
    var closeButtons = Array.prototype.slice.call(root.querySelectorAll("[data-site-mobile-menu-close]"));
    var closeButton = root.querySelector(".site-mobile-menu-drawer__close");
    var lastFocused = null;
    var inertTargets = [document.querySelector("main"), document.querySelector(".site-footer")].filter(Boolean);
    var inertStates = [];

    function isOpen() {
      return root.classList.contains("is-open");
    }

    function setBackgroundInert(isInert) {
      if (isInert) {
        inertStates = inertTargets.map(function (target) {
          var state = { target: target, inert: target.hasAttribute("inert") };
          target.setAttribute("inert", "");
          return state;
        });
        return;
      }

      inertStates.forEach(function (state) {
        if (!state.inert) state.target.removeAttribute("inert");
      });
      inertStates = [];
    }

    function getFocusableElements() {
      return Array.prototype.slice
        .call(root.querySelectorAll('a[href], button:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'))
        .filter(function (element) {
          return (
            element.tabIndex >= 0 &&
            !element.classList.contains("site-mobile-menu-drawer__backdrop") &&
            element.getClientRects().length > 0
          );
        });
    }

    function openDrawer(trigger, event) {
      if (!desktopQuery.matches && !isOpen()) {
        if (event) event.preventDefault();
        if (typeof closeMega === "function") closeMega(false);
        lastFocused = trigger || document.activeElement;
        root.removeAttribute("inert");
        root.setAttribute("aria-hidden", "false");
        root.classList.add("is-open");
        document.body.classList.add("is-mobile-menu-open");
        setBackgroundInert(true);
        triggers.forEach(function (menuTrigger) {
          menuTrigger.setAttribute("aria-expanded", "true");
          menuTrigger.setAttribute("aria-label", "Close menu");
        });
        window.requestAnimationFrame(function () {
          if (closeButton) closeButton.focus();
        });
      }
    }

    function closeDrawer(restoreFocus) {
      if (!isOpen()) return;
      root.classList.remove("is-open");
      document.body.classList.remove("is-mobile-menu-open");
      triggers.forEach(function (menuTrigger) {
        menuTrigger.setAttribute("aria-expanded", "false");
        menuTrigger.setAttribute("aria-label", "Open menu");
      });
      setBackgroundInert(false);
      root.setAttribute("aria-hidden", "true");
      root.setAttribute("inert", "");
      var returnTarget = lastFocused && document.contains(lastFocused) ? lastFocused : triggers[0];
      if (restoreFocus !== false && returnTarget) returnTarget.focus();
    }

    function handleTriggerClick(event) {
      if (isOpen()) {
        closeDrawer(true);
      } else {
        openDrawer(event.currentTarget, event);
      }
    }

    function handleCloseClick() {
      closeDrawer(true);
    }

    function handleRootClick(event) {
      if (event.target.closest("a")) closeDrawer(false);
    }

    function handleDocumentKeydown(event) {
      if (!isOpen()) return;

      if (event.key === "Escape") {
        event.preventDefault();
        closeDrawer(true);
        return;
      }

      if (event.key !== "Tab") return;
      var focusable = getFocusableElements();
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function handleDocumentFocus(event) {
      if (!isOpen() || root.contains(event.target)) return;
      var focusable = getFocusableElements();
      if (focusable.length) focusable[0].focus();
    }

    function handleViewportChange(event) {
      if (event.matches) closeDrawer(false);
    }

    function handleSidecartOpen(event) {
      if (!event.target.closest("[data-sidecart-open]")) return;
      closeDrawer(false);
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener("click", handleTriggerClick);
    });
    closeButtons.forEach(function (button) {
      button.addEventListener("click", handleCloseClick);
    });
    root.addEventListener("click", handleRootClick);
    document.addEventListener("keydown", handleDocumentKeydown);
    document.addEventListener("focusin", handleDocumentFocus);
    document.addEventListener("click", handleSidecartOpen, true);
    addMediaListener(desktopQuery, handleViewportChange);

    return {
      close: closeDrawer,
      cleanup: function () {
        closeDrawer(false);
        triggers.forEach(function (trigger) {
          trigger.removeEventListener("click", handleTriggerClick);
        });
        closeButtons.forEach(function (button) {
          button.removeEventListener("click", handleCloseClick);
        });
        root.removeEventListener("click", handleRootClick);
        document.removeEventListener("keydown", handleDocumentKeydown);
        document.removeEventListener("focusin", handleDocumentFocus);
        document.removeEventListener("click", handleSidecartOpen, true);
        removeMediaListener(desktopQuery, handleViewportChange);
        delete root.dataset.mobileDrawerReady;
      }
    };
  }

  function initialise() {
    if (window.__yntServicesNavigationCleanup) window.__yntServicesNavigationCleanup();

    var headerShell = document.querySelector("[data-site-header]");
    var megaController = enhanceServicesMega(
      document.querySelector("[data-services-mega]"),
      headerShell
    );
    var drawerController = enhanceMobileDrawer(
      document.querySelector("[data-site-mobile-drawer]"),
      megaController.close
    );

    window.__yntServicesNavigationCleanup = function () {
      drawerController.cleanup();
      megaController.cleanup();
      delete window.__yntServicesNavigationCleanup;
    };
  }

  window.__yntServicesNavigationInitialise = initialise;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialise, { once: true });
  } else {
    initialise();
  }

  document.addEventListener("shopify:section:load", initialise);
  document.addEventListener("shopify:section:unload", function (event) {
    var target = event.target;
    var ownsHeader =
      target &&
      ((target.matches && target.matches("[data-site-header]")) ||
        (target.querySelector && target.querySelector("[data-site-header]")));
    if (!ownsHeader || !window.__yntServicesNavigationCleanup) return;
    window.__yntServicesNavigationCleanup();
  });
})();
